import NavBar from '@/components/navbar/bootstrap/NavBar'
import * as React from 'react'

const DefaultLayoutProvider = ({ children }) => {
    return (
        <Layout>
            {children}
        </Layout>
    )
}

const Layout = ({ children }) => {
    return (
        <>
            <NavBar showMenus />
            {React.cloneElement(children)}
        </>
    )
}

export default DefaultLayoutProvider;